import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthState } from "../../context/auth/auth/reducer";
import { History } from "history";
import { ROUTES, ROUTES_KEYS } from "../../routing/routes";
import Navbar from "../../components/shared/navbar/Navbar";
import Footer from "../../components/shared/footer/Footer";
import { GlobalLoadingContext, IGlobalLoadingContext } from "../../providers/GlobalLoading";
import { isFairStarted } from "../../utils/utils";
import { USER_ROLES } from "../../data/enums";
import { BreadcrumbsState } from "../../context/breadcrumbs/reducer";
import { Breadcrumb } from "../../data/interfaces";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  history: History;
  children?: any;
}

const PrivateLayout = ({ history, children, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to loading manager provider that you may use to show and hide global loading
  const { hideGlobalLoading } = useContext<IGlobalLoadingContext>(GlobalLoadingContext);

  // Special layouts which do not need header and footer
  const SPECIAL_LAYOUTS: string[] = [ROUTES.ZOOM_PLAYER];

  // Special layouts which must be visible also if fair hasn't started yet
  const ALWAYS_VISIBLE_LAYOUTS: string[] = [ROUTES.COMPLETE_PROFILE];

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [canProceed, setCanProceed] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  const { history: breadcrumbs } = useSelector(({ breadcrumbsReducer }: { breadcrumbsReducer: BreadcrumbsState }) => {
    return breadcrumbsReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Define if need to show coming soon or not
   * @function
   */
  const showComingSoon = (): boolean => {
    return false;
    return !isFairStarted() && !ALWAYS_VISIBLE_LAYOUTS.includes(history.location.pathname);
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[AuthLayout] init");

    console.log("REDIRECT", history);
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[AuthLayout] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle authorization
   */
  useEffect(() => {
    hideGlobalLoading();
    if (!user) {
      setCanProceed(false);

      history.push({
        pathname: ROUTES.SIGN_IN,
        search: `?redirect_url=${encodeURIComponent(
          history.location.pathname + history.location.search,
        )}`,
      });
      return;
    } else {
      // If profile is not completed and you are a visitor, complete it
      if (user.role === USER_ROLES.VISITOR && !user.profile_completed) {
        setCanProceed(true);
        history.push(ROUTES.COMPLETE_PROFILE);
        return;
      }

      // If I'm not a visitor and I'm going to any profile page, I'll be redirected to home
      try {
        const IM_IN_PROFILE_PAGE: boolean =
          breadcrumbs.filter((b: Breadcrumb) => b.location.key === ROUTES_KEYS.PROFILE).length > 0;
        if (user.role !== USER_ROLES.VISITOR && IM_IN_PROFILE_PAGE) {
          //setCanProceed(true);
          history.push(ROUTES.HOME);
          return;
        }
      } catch (err) {
        console.error(err);
      }

      // If cooming soon
      if (showComingSoon()) {
        setCanProceed(true);
        history.push(ROUTES.COMING_SOON);
        return;
      }

      setCanProceed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="auth-layout">
      {/* Include navbar only if not in special layouts */}
      {!SPECIAL_LAYOUTS.includes(history.location.pathname) && <Navbar/>}

      {canProceed && <div className="main-content">{children}</div>}

      {/* Include footer only if not in special layouts */}
      {!SPECIAL_LAYOUTS.includes(history.location.pathname) && <Footer/>}
    </div>
  );
};
export default PrivateLayout;
